module.exports = new __parcel__URL__("type.7332b6ae.mp3").toString();